
$.fn.isInViewport = ->
  elementTop = $(this).offset().top + 200
  elementBottom = (elementTop + $(this).outerHeight())

  viewportTop = $(window).scrollTop()
  viewportBottom = viewportTop + $(window).height()

  return elementBottom > viewportTop && elementTop < viewportBottom;

window.wet = {
  headerHeight: $('header.header').outerHeight(),
  navHeight: $('#wet-nav').outerHeight(),
  $navObj: $('#wet-nav')
}

window.wetNavBlender = ->
  windowWidth = $(window).width()
  scrollPos = jQuery(window).scrollTop()

  if (windowWidth >= 1200)
    #console.log("desktop")
  else
    #console.log("device")

  if scrollPos >= window.wet.headerHeight
    window.wet.$navObj.show()

    if window.wet.$navObj.hasClass('slideOutDown')
      window.wet.$navObj.removeClass('slideOutDown').addClass('slideInUp')
  else
    window.wet.$navObj.removeClass('slideInUp').addClass('slideOutDown')

window.wetNavActivator = ->
  $('div[id^="wet-area-"]').each ->
    if ($(this).isInViewport())
      areaCode = $(this).attr('id').split('-')[2] || '00'
      $link = window.wet.$navObj.find("a[data-area='"+areaCode+"']")
      if (!$link.hasClass('active'))
        # Remove other clicked nav states.
        window.wet.$navObj.find('a').removeClass('active')
        console.log(window.wet.$navObj.find('a'))
        # Add active state.
        $link.addClass('active')

window.wetClickListeners = ->
  $('#wet-nav li > a').click ->
    area = $(this).data('area')

    $(window).scrollTo("#wet-area-"+area+"", 200, {
      offset: window.wet.navHeight-100
    })
window.wetScrollListners = ->
  $(document).scroll ->
    window.wetNavBlender()
    window.wetNavActivator()


$(document).ready ->
  if ($('#wet-nav'))
    window.wetClickListeners()
    window.wetScrollListners()